// @ts-nocheck
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import './Header.css';
import Branding from './Branding/Branding';
import { getLastListItem } from '../../../../../utils/common';
import { getOldCoverImageUrl } from '../../../../../utils/getCoverImageUrl';
import Editor from '../../../../Editor/Editor';

const Header = ({ trip, id, tenantSettings, tenant }) => {
  if (!trip || !tenantSettings) return null;

  const coverImage = getLastListItem(trip.tripimage);
  const { bodyfont, headingfont } = tenantSettings;
  const hideImagesInPdf = tenantSettings?.showImagesInPdf === false;

  return (
    <Box className='header' sx={{ fontFamily: bodyfont }} id={id}>
      <Branding
        id={'header-branding'}
        tenantSettings={tenantSettings}
        trip={trip}
        tenant={tenant}
      />

      <Box className='header__text'>
        <Typography
          variant='h3'
          fontWeight='bold'
          className='header__title'
          fontFamily={headingfont}
          fontSize={'1.875rem'}
        >
          {trip.tripname}
        </Typography>
      </Box>

      {trip?.description && trip.description.trim() !== '' && (
        <Box className='header__description'>
          <Editor
            id={`${id}-description-editor`}
            content={trip.description}
            editable={false}
            isPreviewing={true}
            style={{ fontFamily: bodyfont || 'inherit' }}
            fontSize={'0.8rem'}
          />
        </Box>
      )}

      {coverImage && (
        <img
          src={getOldCoverImageUrl(coverImage.imageurl, 'LG')}
          alt={trip.tripname}
          className={`header__image ${hideImagesInPdf ? 'noprint' : ''}`}
        />
      )}
    </Box>
  );
};

Header.propTypes = {
  id: PropTypes.string.isRequired,
  trip: PropTypes.shape({
    startdate: PropTypes.string,
    duration: PropTypes.number,
    tripname: PropTypes.string,
    tripimage: PropTypes.arrayOf(
      PropTypes.shape({
        tripimageid: PropTypes.number,
        seq: PropTypes.number,
        imageurl: PropTypes.string
      })
    ),
    description: PropTypes.string,
    createdbyuser: PropTypes.shape({
      login: PropTypes.string
    })
  }).isRequired,
  tenant: PropTypes.shape({
    tenantlogo: PropTypes.string,
    tenantphone: PropTypes.string,
    tenantname: PropTypes.string,
    tenanturl: PropTypes.string
  }),
  tenantSettings: PropTypes.shape({
    bodyfont: PropTypes.string,
    headingfont: PropTypes.string,
    showImagesInPdf: PropTypes.bool,
    showOperatorInfo: PropTypes.bool
  })
};

export default Header;
